function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3867",
  "data-name": "Rectangle 3867",
  width: 30,
  height: 30,
  rx: 15,
  fill: "#2fcc71"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2632",
  "data-name": "Path 2632",
  d: "M651.278,80.613a2.514,2.514,0,0,0-.883-.546L649.71,77.4l8.16-2.283.874,3.407Zm-2.6-7.225,5.44-1.521.875,3.408-5.44,1.522Zm.244,6.627a2.547,2.547,0,0,0-.43.171l-2.4-9.346h-.9a.558.558,0,0,1-.5.336h-1.126a.589.589,0,0,1,0-1.176h1.126a.548.548,0,0,1,.45.251h1.733v.029l.026-.008,2.48,9.665A2.62,2.62,0,0,0,648.924,80.015Zm.146.568a1.964,1.964,0,0,1,2.414,1.456,2.069,2.069,0,0,1-1.394,2.52,1.965,1.965,0,0,1-2.414-1.456A2.069,2.069,0,0,1,649.07,80.583Zm-.3,2.252a.841.841,0,0,0,1.035.623.886.886,0,0,0,.6-1.08.842.842,0,0,0-1.034-.624A.888.888,0,0,0,648.773,82.835Zm9.9-2.313L652.1,82.36a2.7,2.7,0,0,0-.074-.474,2.66,2.66,0,0,0-.163-.45l6.538-1.828Z",
  transform: "translate(-637 -61)",
  fill: "#fff"
});

function SvgStep4Active(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shipping",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Active);
export default __webpack_public_path__ + "static/media/step4active.fa45f47f.svg";
export { ForwardRef as ReactComponent };